import { t } from 'ember-intl';
import { PhCalendarDots } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';
import type { AppHistoryBase } from '../../../../types/tuition-assistance.ts';
import ApplicationHistoryTimeline from '../../application-history-timeline.gts';
import { DrawerHeader, DrawerBody } from 'tio-reimagined/components/drawer';

/**
 * Timeline drawer content component
 * Uses ApplicationHistoryTimeline in embedded mode (no header/border)
 */
export interface TimelineDrawerSignature {
  Args: {
    history: AppHistoryBase[];
  };
}

const TimelineDrawer: TOC<TimelineDrawerSignature> = <template>
  <DrawerHeader>
    <h2 class="text-lg font-semibold text-gray-800">{{t
        "tuition_assistance.application_approval.timeline"
      }}</h2>
  </DrawerHeader>

  <DrawerBody>
    <div class="mb-6">
      {{#if @history.length}}
        <ApplicationHistoryTimeline @history={{@history}} @embedded={{true}} />
      {{else}}
        <div class="p-6 text-center">
          <PhCalendarDots @size="48" class="text-gray-300 dark:text-gray-600 mx-auto mb-4" />
          <p class="text-gray-500">
            {{t "tuition_assistance.application_approval.no_timeline_data"}}
          </p>
        </div>
      {{/if}}
    </div>
  </DrawerBody>
</template>;

export default TimelineDrawer;
